export interface SupabaseAuthEnv {
  url: string;
  publishableKey: string;
  storageKey: string;
}

export const supabaseAuthProd: SupabaseAuthEnv = Object.freeze({
  url: 'https://bxoujxvtejswxowvjmvn.supabase.co',
  publishableKey: 'sb_publishable_5v2-ukUZxw7vA6cMzVxk2g_oFc_dVyT',
  storageKey: 'web-mp-account-supabase-auth-prod',
});

export const supabaseAuthDev: SupabaseAuthEnv = Object.freeze({
  url: 'https://axjbybjabmkyqehvrijj.supabase.co',
  publishableKey: 'sb_publishable_eVN8Kppb69dk8Ml6oXHPTw_xLEFAvGh',
  storageKey: 'web-mp-account-supabase-auth-dev',
});

/** Same Supabase Auth projects as web-iot-admin (this app centralizes the same login). */
export function resolveSupabaseAuthEnv(production: boolean): SupabaseAuthEnv {
  return production ? supabaseAuthProd : supabaseAuthDev;
}
